import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import assessmentPackBanner from "../../../assets/assessment-pack-banner.png";
import iconImpactedObjects from "../../../assets/icon-impacted-objects.svg";
import type { AssessmentPackImpactedType } from "../../../services/implementationRecordService";

type AssessmentPackBannerProps = Readonly<{
  title: string;
  impactedObjectTypes: readonly AssessmentPackImpactedType[];
}>;

const bannerPillSx = {
  height: 22,
  borderRadius: "10px",
  bgcolor: "#FFFFFF",
  color: "#404040",
  fontSize: 12,
  fontWeight: 600,
  "& .MuiChip-label": {
    px: 1,
    py: 0.5,
    lineHeight: "14px",
  },
} as const;

export default function AssessmentPackBanner({
  title,
  impactedObjectTypes,
}: AssessmentPackBannerProps) {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: "12px",
        px: 3,
        pt: 3,
        pb: 2.5,
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          backgroundImage:
            "linear-gradient(180deg, rgba(255,255,255,0.25) 0%, rgba(217,235,255,0.5) 100%)",
        }}
      />
      <Box
        component="img"
        src={assessmentPackBanner}
        alt=""
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.35,
          pointerEvents: "none",
        }}
      />

      <Box sx={{ position: "relative", display: "flex", flexDirection: "column", gap: 3 }}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 500,
            lineHeight: "28px",
            color: "#101828",
            letterSpacing: "0.07px",
          }}
        >
          {title}
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              component="img"
              src={iconImpactedObjects}
              alt=""
              sx={{ width: 16, height: 16, display: "block" }}
            />
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 500,
                color: "#8C8C8C",
                textTransform: "capitalize",
              }}
            >
              Impacted Items
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {impactedObjectTypes.length > 0 ? (
              impactedObjectTypes.map((item) => (
                <Chip
                  key={`${item.objectType}:${item.objectSubType}`}
                  size="small"
                  label={item.displayName}
                  sx={bannerPillSx}
                />
              ))
            ) : (
              <Typography sx={{ fontSize: 13, color: "#8C8C8C" }}>None</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
